import { render, staticRenderFns } from "./m_award.vue?vue&type=template&id=0b17a2e2&scoped=true&"
import script from "./m_award.vue?vue&type=script&lang=js&"
export * from "./m_award.vue?vue&type=script&lang=js&"
import style0 from "./m_award.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./m_award.vue?vue&type=style&index=1&id=0b17a2e2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b17a2e2",
  null
  
)

export default component.exports